/**
 * Domain identifiers used by metadata + permission lookups.
 *
 * Values mirror the Vue ERP source-of-truth at
 * `RW-ERP-Service/src/types/constants/entity-Id.ts`. Keep both files
 * aligned — these UUIDs are server-side keys and changing them silently
 * breaks every downstream consumer.
 *
 * `REACT_DOMAIN_IDS` is the bulk-fetch list `getAttributeMetaData()` sends
 * in its single domain-search call (Vue ERP equivalent: the hardcoded
 * array in `api/metaData/meta-data.api.ts:30-42`). Add a domain here when
 * a new React feature needs its metadata.
 */

export const ORDERS_DOMAIN_ID = 'c67a9fb5-edeb-4f28-9343-00dd8af14746';
export const AR_CONTACT_DOMAIN_ID = 'b3a1c2d4-e5f6-7890-abcd-ef1234567890';

/**
 * Products domain — `tbl_domains.id` for "Products". Vue source-of-truth:
 * `RW-ERP-Service/src/types/constants/domain.ts`, `productsId`. Owns the
 * domain attributes CEO Pricing's saved column view is keyed on; lives here
 * rather than in the feature folder so a second screen that needs it reuses
 * this export instead of re-declaring the UUID.
 */
export const PRODUCTS_DOMAIN_ID = 'd254c55a-7e1a-4e24-b792-3c9c2b16efb2';

/**
 * Single source of truth for the bulk metadata fetch. Append-only —
 * removing a domain from this list breaks features that depend on it.
 */
export const REACT_DOMAIN_IDS: ReadonlyArray<string> = [
  ORDERS_DOMAIN_ID,
  AR_CONTACT_DOMAIN_ID,
];
